import React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Button, IconButton, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useScheduleCalendarContext from 'components/ScheduleCalendar/context/useScheduleCalendarContext';
import { daysInWeek } from 'helpers/timeConsts';
import monthLabels from 'helpers/monthLabels';

export default function ScheduleNavigator() {
  const { t } = useTranslation();
  const { setCurrentDate, currentDate } = useScheduleCalendarContext();
  const currentDateMonth = currentDate.getMonth();
  const monthLabel = monthLabels[parseInt(currentDateMonth.toString(), 10)];
  const currentDateYear = currentDate.getFullYear();

  const handleTodayClick = () => {
    setCurrentDate(new Date());
  };

  const handlePrevClick = () => {
    setCurrentDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() - daysInWeek);
      return newDate;
    });
  };

  const handleNextClick = () => {
    setCurrentDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() + daysInWeek);
      return newDate;
    });
  };

  return (
    <Stack alignItems="center" direction="row" spacing={1}>
      <Button onClick={handleTodayClick} variant="outlined">
        <Typography color="secondary.main" variant="buttonMedium">
          {t('label.today')}
        </Typography>
      </Button>
      <Stack direction="row">
        <IconButton onClick={handlePrevClick}>
          <ChevronLeftIcon sx={{ fontSize: '2rem' }} />
        </IconButton>
        <IconButton onClick={handleNextClick}>
          <ChevronRightIcon sx={{ fontSize: '2rem' }} />
        </IconButton>
      </Stack>
      <Typography variant="h6" sx={{ userSelect: 'none' }}>
        {t(monthLabel)} {currentDateYear}
      </Typography>
    </Stack>
  );
}
